<!-- Settings Dashboard -->
<div class="py-6 bg-surface-secondary" *ngIf="isSettingsHome">
  <div class="container-fluid max-w-screen-lg">
    <div class="mb-5">
      <h3 class="mb-1">Settings</h3>
      <p class="text-sm text-muted">Manage your account and preferences</p>
    </div>

    <!-- Account -->
    <div class="settings-group">
      <div class="settings-group-label">Account</div>
      <div class="settings-grid">
        <a class="settings-card" routerLink="/settings/general">
          <div class="settings-card-icon">
            <i class="bi bi-person"></i>
          </div>
          <div class="settings-card-body">
            <h6>General</h6>
            <p>Profile, logo, company details & preferences</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
        <a class="settings-card" routerLink="/settings/change-password">
          <div class="settings-card-icon">
            <i class="bi bi-lock"></i>
          </div>
          <div class="settings-card-body">
            <h6>Change Password</h6>
            <p>Update your account password</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
      </div>
    </div>

    <!-- Company -->
    <div class="settings-group" *ngIf="user.role_uuid === ROLES.AGENCY">
      <div class="settings-group-label">Company</div>
      <div class="settings-grid">
        <a class="settings-card" routerLink="/settings/address-bank-details">
          <div class="settings-card-icon">
            <i class="bi bi-building"></i>
          </div>
          <div class="settings-card-body">
            <h6>Address & Bank Details</h6>
            <p>Company address and banking information</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
      </div>
    </div>

    <!-- Timesheets -->
    <div class="settings-group" *ngIf="user.role_uuid === ROLES.AGENCY">
      <div class="settings-group-label">Timesheets & Reminders</div>
      <div class="settings-grid">
        <a class="settings-card" routerLink="/settings/onboarding-forms">
          <div class="settings-card-icon">
            <i class="bi bi-person-check"></i>
          </div>
          <div class="settings-card-body">
            <h6>Onboarding Forms</h6>
            <p>Manage candidate onboarding forms</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
        <a class="settings-card" routerLink="/settings/timesheet-forms">
          <div class="settings-card-icon">
            <i class="bi bi-file-earmark-text"></i>
          </div>
          <div class="settings-card-body">
            <h6>Timesheet Forms</h6>
            <p>Manage timesheet form templates</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
        <a class="settings-card" routerLink="/settings/reminder">
          <div class="settings-card-icon">
            <i class="bi bi-bell"></i>
          </div>
          <div class="settings-card-body">
            <h6>Reminder</h6>
            <p>Configure timesheet reminders</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
      </div>
    </div>

    <!-- Integrations -->
    <div class="settings-group" *ngIf="user.role_uuid === ROLES.AGENCY">
      <div class="settings-group-label">Integrations</div>
      <div class="settings-grid">
        <a class="settings-card" routerLink="/settings/integrations">
          <div class="settings-card-icon">
            <i class="bi bi-plug"></i>
          </div>
          <div class="settings-card-body">
            <h6>Integrations</h6>
            <p>Connect third-party services</p>
          </div>
          <i class="bi bi-chevron-right settings-card-arrow"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Detail View -->
<div *ngIf="!isSettingsHome">
  <div class="settings-back-bar">
    <div class="container-fluid max-w-screen-lg">
      <a class="settings-back-link" routerLink="/settings">
        <i class="bi bi-arrow-left"></i>
        <span>Back to Settings</span>
      </a>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
